import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a1ecb312"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "create-ltl-order" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_step_client = _resolveComponent("step-client")!
  const _component_step_senders_spark = _resolveComponent("step-senders-spark")!
  const _component_step_date_spark = _resolveComponent("step-date-spark")!
  const _component_step_receivers_spark = _resolveComponent("step-receivers-spark")!
  const _component_step_create = _resolveComponent("step-create")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Создание заказа Spark.kz" }),
      _createVNode(_component_the_button, {
        class: "second text small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_step_client, {
      class: "mt-6",
      "step-number": 1,
      disabled: _ctx.isDisabled,
      "client-id": _ctx.payload.clientclientId,
      onSubmit: _ctx.onClientSubmit,
      onReset: _ctx.resetOrder
    }, null, 8, ["disabled", "client-id", "onSubmit", "onReset"]),
    _createVNode(_component_step_senders_spark, {
      class: "mt-6",
      "step-number": 2,
      opened: _ctx.isClientSelected,
      "client-id": _ctx.payload.clientId,
      disabled: _ctx.isDisabled,
      onSubmit: _ctx.onSenderSubmit,
      onReset: _ctx.onSenderReset
    }, null, 8, ["opened", "client-id", "disabled", "onSubmit", "onReset"]),
    _createVNode(_component_step_date_spark, {
      class: "mt-6",
      "step-number": 3,
      opened: _ctx.isSenderSelected,
      disabled: _ctx.isDisabled,
      onSubmit: _ctx.onDateSubmit,
      onReset: _ctx.onDateReset
    }, null, 8, ["opened", "disabled", "onSubmit", "onReset"]),
    _createVNode(_component_step_receivers_spark, {
      class: "mt-6",
      "step-number": 4,
      opened: _ctx.isDateSelected,
      disabled: _ctx.isDisabled,
      onSubmit: _ctx.onReceiverSubmit,
      onReset: _ctx.onReceiverReset
    }, null, 8, ["opened", "disabled", "onSubmit", "onReset"]),
    (_ctx.isCreate)
      ? (_openBlock(), _createBlock(_component_step_create, {
          key: 0,
          class: "mt-3",
          created: _ctx.state.is_order_created,
          loading: _ctx.state.is_creating_order,
          onSubmit: _ctx.onSubmitOrder,
          onNewOrder: _ctx.resetOrder
        }, null, 8, ["created", "loading", "onSubmit", "onNewOrder"]))
      : _createCommentVNode("", true)
  ]))
}